import { defineFcm } from '../shared/factory';

export const FCM_MOBILE_APP_DOWNLOAD_BOTTOM_BANNER_ENABLED = defineFcm('mobile_app_download_bottom_banner_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig();
